import axiosInst from "./config/axiosConfig";

const updateMfaStatus = async (body: any) => axiosInst.put("/beta/mfaActionsUIHook", body);

const getUserGroup = async (body: any) => axiosInst.post("/beta/UserGroups", body);

const changePassword = async (body: any) => axiosInst.post("/beta/usersChangePwd", body);

const updateUserSetting = async (body: any) => axiosInst.post("/beta/usersUpdate", body);

export { updateMfaStatus, getUserGroup, changePassword, updateUserSetting };
